"use client";

import Link from "next/link";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useTranslations } from "@/i18n/LocaleProvider";

export default function NotFound() {
  const { t } = useTranslations();
  return (
    <>
      <Header />
      <main className="mx-auto w-full max-w-md px-6 py-24 text-center">
        <h1 className="font-display text-4xl">{t("errors.notFoundTitle")}</h1>
        <p className="mt-4 text-foreground/70">{t("errors.notFoundBody")}</p>
        <Link
          href="/"
          className="mt-8 inline-block rounded-xl bg-accent px-6 py-3 font-semibold text-accent-foreground"
        >
          {t("errors.backHome")}
        </Link>
      </main>
      <Footer />
    </>
  );
}
